import { render, staticRenderFns } from "./FormDateInput.vue?vue&type=template&id=bbb37432&scoped=true"
import script from "./FormDateInput.vue?vue&type=script&lang=js"
export * from "./FormDateInput.vue?vue&type=script&lang=js"
import style0 from "./FormDateInput.vue?vue&type=style&index=0&id=bbb37432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb37432",
  null
  
)

export default component.exports